import {instance} from '../index';

export const financeTypesApi = {
  getFees () {
    return instance.get('finance-types/fees')
  },
  updateFee (id, data) {
    return instance.put(`finance-types/fees/${id}`, data)
  },
  getTaxes () {
    return instance.get('finance-types/taxes')
  },
  updateTax (id, data) {
    return instance.put(`finance-types/taxes/${id}`, data)
  },
  getMarkups () {
    return instance.get('finance-types/markups')
  },
  updateMarkup (id, data) {
    return instance.put(`finance-types/markups/${id}`, data)
  },
  getCostRangeMarkups () {
    return instance.get('finance-types/cost-range-markups')
  },
  createCostRangeMarkup (data) {
    return instance.post('finance-types/cost-range-markups', data)
  },
  updateCostRangeMarkup (id, data) {
    return instance.put(`finance-types/cost-range-markups/${id}`, data)
  },
  deleteCostRangeMarkup (id) {
    return instance.delete(`finance-types/cost-range-markups/${id}`)
  },
}
